import { cn } from "@/lib/utils";
import { Link } from "react-router-dom";
import { useTheme } from "@/components/ThemeProvider";
import { useLabel } from "@/providers/LabelProvider";

interface LogoProps {
  isCollapsed: boolean;
}

export function Logo({ isCollapsed }: LogoProps) {
  const { theme } = useTheme();
  const { label } = useLabel();
  const logoSrc = theme === 'dark' ? "/zen-logo.png" : "/zen-black-logo.png";
  const displayName = label?.name || "Zen";

  return (
    <div className={cn(
      "flex items-center",
      isCollapsed ? "justify-center" : "justify-start"
    )}>
      <Link to="/" className="flex items-center gap-3 text-foreground hover:text-foreground min-w-0">
        <img src={logoSrc} alt={displayName} className="w-8 h-8 object-contain flex-shrink-0" />
        {!isCollapsed && (
          <span className="text-foreground font-semibold text-lg truncate">{displayName}</span>
        )}
      </Link>
    </div>
  );
}